import Component from '../inherited/Component'
import axios from 'axios'

export default class MethodCall extends Component {
  constructor (elem, theme, options, ctx) {
    super(elem, theme, options, ctx)
  }

  async mount () {
    let doCheck = false
    let lastCheck = localStorage.getItem('R_LAST_MEMBER_CHECK')
    let now = new Date().getTime()

    if (lastCheck) {
      let difference = now - lastCheck
      if (difference >= (1000 * 60 * 5)) {
        doCheck = true
      }
    } else {
      doCheck = true
    }

    if (doCheck) {
      try {
        await axios.get(`${this._ctx.getState().member_endpoint}/api/soho/check`, {
          params: {
            shop: window.Shopify.shop,
            customer: this._options.customer,
            email: this._options.email
          }
        })
      } catch (e) {
        console.error(e)
      } finally {
        localStorage.setItem('R_LAST_MEMBER_CHECK', now)
      }
    }
  }
}